var setHeight = function() {  
  var top = 0;
  if( $('#shopify-section-header').length ){
    top = $('#shopify-section-header').outerHeight();
  }else{
    top = $($('.shopify-section-group-header-group.section-header')[0]).outerHeight();    ;
  }  
  $('.mega-menu-main').css({'height': 'calc(100vh - ' + top + 'px)'});
}

proSlickSlider();

$(window).on('load',function() {
  setHeight();
  /* Remove hidden calss for the iframe bf-hero-banner */
  if($('iframe.hidden').length > 0){
    $('iframe.hidden').removeClass('hidden');
    $('iframe[data-src]').each(function(){
      var _this = $(this);
      setTimeout(function(){
        _this.attr('src', _this.attr('data-src'));
      },250);
    });
  }
  /* Remove hidden calss for the iframe  */
  // new-hero-sectionsection Tow image layout 4 -- for the mobile
  twoImgTLay4();
  // new-hero-sectionsection Tow image layout 4 -- for the mobile
});

$(window).on('resize',function() {
  setHeight();
});

/* section spacing new-banner-section */
 $('[data-section-spacing]').each(function(){
   var _json = JSON.parse($(this).text());
   $('#'+ _json.sectionId ).addClass(_json.spacing);
 });
/* section spacing */

$(document).ready(function(){

  //Mega-menu
  navigationMegaMenu();

  var stickyFilter = function(event) {
      //this is for temp collection --> collection.new
      var collFilter = $("body.temp-new-suffix .collection-filter-bar").offset().top;
      var headerHeight = $(".header").outerHeight();
      if((window.pageYOffset + 5) >= (collFilter - headerHeight) ){
        $("body.temp-new-suffix .collection-filter-bar").addClass("sticky-filter");
      }else{
        $("body.temp-new-suffix .collection-filter-bar").removeClass("sticky-filter");
      }
  }

  //add class to header
  $(window).scroll(function(){
    if( document.querySelector('.js header-drawer .menu-drawer') && window.innerWidth < 990 ){      
      let _winHeight = window.innerHeight; 
      if( document.querySelector('.announcement-bar') && $(this).scrollTop() < document.querySelector('.announcement-bar').clientHeight ){
        _winHeight = _winHeight - document.querySelector('.announcement-bar').clientHeight;          
      }
      if( document.querySelector('.js header-drawer .menu-drawer .menu-drawer__inner-container') ){
        document.querySelector('.js header-drawer .menu-drawer .menu-drawer__inner-container').style.height = 'auto';
        if( (document.querySelector('.js header-drawer .menu-drawer .menu-drawer__inner-container').clientHeight + 40 ) <= _winHeight ){
          document.querySelector('.js header-drawer .menu-drawer .menu-drawer__inner-container').style.height = '';
        }
      }
      document.querySelector('.js header-drawer .menu-drawer').style.height = _winHeight+'px';
    }
    if ($(this).scrollTop() > 50) {
     $('body').addClass('fix-header');
      $('.mega-menu-li.active_main').removeClass('active_main');
      $('li.has-megamenu.active').removeClass('active');
      $('.transparent_bg_header').removeClass('mouseActive');
    } else {
     $('body').removeClass('fix-header');
    }
    if( $('.currency-language-switcher .HorizontalList__Item.active').length > 0 ){
      $('.currency-language-switcher .HorizontalList__Item.active').removeClass('active');
    }

    //for collection page [ template == new ] --> sticky filter
    if($("body.temp-new-suffix").length){
      var timeout;
      clearTimeout(timeout);
      timeout = setTimeout(stickyFilter, 500);
    }
    return false;
  });
  //END- add class header
  
  //Product-page tab acrodian
  $("#pro-accordion .accordion-box .title").click(function (e) {
    e.preventDefault();
    $('#pro-accordion').find('.panel').not($(this).next()).slideUp(400);
    $('.active').not(this).removeClass('active');
    $(this).toggleClass('active');
    $(this).next().slideToggle(400);
  });
  //Product-page tab acrodian - END

  //Featured products slick slider
  $('.featured-collection-sliders:not(role="list")').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
  });
  //Featured products slider - END

  //START - home page featured collection slider
  if ($(window).width() > 989 ) {
    $('.collection-list-new .collection-list').slick({
    infinite: true,
    arrows: true,
    slidesToShow: 8,
    slidesToScroll: 8,
    touchThreshold: 800,
    swipeToSlide: true,
    responsive: [
        {
          breakpoint: 1700,
          settings: {
            slidesToShow: 7,
            slidesToScroll: 7
          }
        },
        {
          breakpoint: 1350,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        }
      ]
    });    
  }
  //END - home page featured collection slider

  //START - Collection shop list
  if ($(window).width() > 989 ) {
    $('.collection-shop-list .collection-list').slick({
      infinite: true,
      slidesToShow: 7,
      slidesToScroll: 7,
      touchThreshold: 500,
      speed: 1000,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6
          }
        },
        {
          breakpoint: 1350,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            speed: 600
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
            speed: 600
          }
        }
      ]
    });
  }
  //END - Collection shop list
  
  //START - home page featured collection slider new
  if ($(window).width() > 990 ) {      
      $('.featured-collection-new .featured-coll-slider-new').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 3,
        arrows: true,
        swipeToSlide: true,
        touchThreshold:500,
        responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
              }
            }
          ]
      });
    }
  //END - home page featured collection slider new


  //START - landing-collection-slider
  if ($(window).width() >= 750 ) {
    $('[data-landing-collection-slider]').each(function(index){
      
      $(this).on('init', function(event, slick){
        // console.log("initialized",$(this));
        var height = 0;
        var slider = $(this);
        setTimeout(function(){
          slider.find('.grid__item').each(function(){
            var h = slider.find(".card > .card__content").height();
            if(h > height){
              height = h;
            }
          });
          slider.find(".slick-arrow").css("margin-top",-Math.abs(height/2));
        },1000);
      });
      var slide_to_show = $(this).attr("data-slide-to-show");
      $(this).slick({
        infinite: true,
        slidesToShow: slide_to_show,
        slidesToScroll: slide_to_show,
        // arrows: false,
        swipeToSlide: true,
        // touchThreshold:500,
        responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            }
          ]
      });

    });

  }else{
    $('[data-landing-collection-slider]').each(function(index ,element ){
      $(this).scroll(function(){
        var left = this.scrollLeft * 100 / ($(this)[0].scrollWidth - $(window).width());
        var count = left * $(this).closest("slider-component").find(".slider-scroll-track").width() / 100;
        $(this).closest("slider-component").find(".slider-scroll-track span").css("left",`${count}px`);
      });
    });
  }

  // landing-collection-slider -- load more btn [ mobile view ]
  $(document).on('click','[data-landing-coll-loadmore]', function(e){
    e.preventDefault();
    var btn = $(this);
    $(this).addClass("loading");
    setTimeout(function(){
      btn.removeClass("loading");
      btn.addClass("disabled hidden");
      btn.closest('slider-component').find('.grid__item:not(:nth-child(-n+4))').fadeIn();
    },500);
  });
  //END - landing-collection-slider

  // landing-collage.liquid -- load more btn [ mobile view ]
  $(document).on('click','[data-landing-pro-grid-loadmore]', function(e){
    e.preventDefault();
    var btn = $(this);
    $(this).addClass("loading");
    setTimeout(function(){
      btn.removeClass("loading");
      btn.addClass("disabled hidden");
      btn.closest('[data-image-pro-grid]').find('.grid__item:not(:nth-child(-n+4))').fadeIn();
    },500);
  });

  //START - Featured Pros List
  $('.featured-pros-list-slide').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    variableWidth: true,
    swipeToSlide: true,
    touchThreshold:500,
    responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        }
      ]
  });
  //END - Featured Pros List

  /* Slick scroll on wheel */
  // use x and y mousewheel event data to navigate flickity
  function slick_handle_wheel_event(e, slick_instance, slick_is_animating) {
    // do not trigger a slide change if another is being animated
    if (!slick_is_animating) {
      // pick the larger of the two delta magnitudes (x or y) to determine nav direction
      var direction =
        Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
  
      // console.log("wheel scroll ", e.deltaX, e.deltaY, direction);
  
      if (direction > 0) {
        // next slide
        slick_instance.slick("slickNext");
      } else {
        // prev slide
        slick_instance.slick("slickPrev");
      }
    }
  }

  // debounce the wheel event handling since trackpads can have a lot of inertia
  var slick_handle_wheel_event_debounced = debounce(slick_handle_wheel_event, 100);
  $('.slick-initialized').each(function(){})
  $(window).on('load',function(){
    /*// slider #1
    const slick_1 = $('.slick-initialized');
    // slick_1.slick({
    //   dots: true
    // });
    var slick_1_is_animating = false;
    
    slick_1.on("afterChange", function(index) {
      console.log("Slide settle " + index);
      slick_1_is_animating = false;
    });
    
    slick_1.on("beforeChange", function(index) {
      console.log("Slide selected " + index);
      slick_1_is_animating = true;
    });
    
    slick_1.on("wheel", function(e) {
      slick_handle_wheel_event_debounced(e.originalEvent, slick_1, slick_1_is_animating);
    });*/
  })
  /* Slick scroll on wheel */

  //Product page tooltip - START
  $('.product__info-container .tooltip-wrap .tooltip-img').on('click',function(e){
    e.preventDefault();
    $(this).closest('.tooltip-wrap').find('.tooltip-txt').toggleClass('active');
  });
  //Product page tooltip - END

  //FAQ expanded - START
  $('.Faq__Question').on('click',function(event){
    var item = $(this).closest('.Faq__Item');
    if ($(item).attr('aria-expanded') === 'true') {      
      var answerWrapper = $(item).find('.Faq__AnswerWrapper');

      $(item).attr('aria-expanded', 'false');
      $(answerWrapper).attr('aria-hidden', 'true');
      $(answerWrapper).slideUp();
    } else {
      var answerWrapper = $(item).find('.Faq__AnswerWrapper');


      $(answerWrapper).attr('aria-hidden', 'false');
      $(answerWrapper).slideDown(true);
      $(item).attr('aria-expanded', 'true');

      
      $(item).siblings('[aria-expanded="true"]').each(function () {
        var siblingAnswerWrapper = $(this).find('.Faq__AnswerWrapper');
        $(this).attr('aria-expanded', 'false');
        $(siblingAnswerWrapper).attr('aria-hidden', 'true');
        $(siblingAnswerWrapper).slideUp();
      })
    }
  });
  $('.FaqSummary__Item').on('click',function(event){
    $(this).addClass('is-active');
    $(this).siblings('.is-active').each(function () {
      $(this).removeClass('is-active');
    })
  });  
  //FAQ expanded - END
  
  $('li.grid__item').each(function(){
    var store_pos = [];
    if($(this).find(".ProductItem__ColorSwatchList").length > 0){ 
      $(this).find(".ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem:not('.hide')").each(function(index){
        if($(this).hasClass('soldOutColor')){
          store_pos.push(index);    
        }
      }); 
      $(this).find(".ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem:not('.hide')").each(function(index){
        if(store_pos.indexOf(index) == -1){
          if(!$('body').hasClass("page-landing-1") && !$('body').hasClass("page-landing-2") && !$('body').hasClass("temp-index")){
            $(this).find('label').trigger('click');
          }
          return false;
        }
      });
    }
  });
  
  if($('.template-404').length > 0){
    let searchParams = new URLSearchParams(window.location.search);
    let param = searchParams.has('link_redirect');
    if(param == true){
      window.location.href = "/";
    }
  }

  

  setTimeout(function(){
    if( $('.product-form__input ul li.soldout-variant.active.notAllSoldOut input:checked+label').length > 0 ){
      window.onPageLoad = true;
    }
    $('.product-form__input ul li input:checked+label').trigger('click');
  }, 1200);

  blackFridayVarinats();

  $(document).on('click','variant-color .ColorSwatchList .colorList_item',function(e){           
    var _this = $(this);  
    if( !_this.hasClass('active') ){
      $('variant-color .ColorSwatchList .colorList_item.active').removeClass('active');      
      _this.addClass('active');
      setTimeout(function(){
        var _val = _this.find('input:checked').attr('data-value');
        var _slider = $('.product media-gallery slider-component .product__media-list.slider_true');
        if( $('.product media-gallery slider-component .product__media-list.slider_false.sliderMobile_true').length > 0 && $(window).width() < 750 ){
          _slider = $('.product media-gallery slider-component .product__media-list.slider_false.sliderMobile_true');
        }
        proSlickFilter(_val,_slider);
      },250);
    }
    productDetailsRight(_this.find('input:checked').attr('data-value'));
  });
  
  //collection template == new -- sale btn click event
  $('body').on('click','[data-sale-btn]',function(){
    $(this).toggleClass("active");
    if($(this).hasClass("active")){
      $(".grid__item").filter("[data-compare-price='false']").addClass("sale-hidden");
      if($(".grid__item[data-compare-price='true']").length <= 4){
        if(document.querySelector("#AjaxinatePagination .pagination__item") ) document.querySelector("#AjaxinatePagination .pagination__item").click();
      }
    }else{
      $(".grid__item").removeClass("sale-hidden");
    }
  });


  // new-hero-sectionsection Tow image layout 4 -- for the mobile
  twoImgTLay4();
  // new-hero-sectionsection Tow image layout 4 -- for the mobile

  $('.slick-initialized').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    if( !$(slick.$slider).hasClass('slideChanged') ){
      $(slick.$slider).addClass('slideChanged');
    }
  });

});

function twoImgTLay4(){  
  if( $(window).width() < 750 ){
    $('.banner--content-align-mobile-twoImg-TLay-4 .banner__media, .banner--content-align-mobile-twoImg-TLay-4 .banner__content').css('min-height','');
    $('.banner--content-align-mobile-twoImg-TLay-4').each(function(){
      var _thisMain = $(this);
      $(this).find('.banner__content').each(function(index, ele){
        var _class = '.banner__media_'+(index+1);
        var _bannerImg = $(_thisMain.find(_class));
        if( $(this).outerHeight(true) > _bannerImg.outerHeight(true) ){
          _bannerImg.css('min-height', ($(this).outerHeight(true) +50 )+'px' );
          $(this).css('min-height', ($(this).outerHeight(true) +50 )+'px' );
          console.log( $(this).outerHeight(true), _bannerImg.outerHeight(true) );
        }
      });
    });
  }
  return;
}
  
function navigationMegaMenu(){

  //add class only if user is used mac machine
  if (navigator.userAgent.indexOf('Mac OS X') != -1) {
    $("body").addClass("mac-os-user");
  }
  
  // open 3rd level mega menu
  // $('.shop-mega-menu .mega-menu-list > li').on('mouseenter',function(e){
  //   const _this = $(this);    
  //   if($(this).hasClass('has-megamenu')){
  //     setTimeout(function(){
  //     _this.closest('.mega-menu-list-div').find('li.has-megamenu').removeClass('active');
  //     _this.addClass('active');
  //       })
  //   }else{
  //     $(this).closest('.mega-menu-list-div').find('li.has-megamenu').removeClass('active');
  //   }
  // });
  $(document).on('mouseenter','.shop-mega-menu .mega-menu-list > li.has-megamenu .has-megamenu-text, .shop-mega-menu .mega-menu-list > li>div>.header__menu-item',function(e){
    // console.log("mouseneter");
    const _this = $(this);
    if($(this).parents("li").hasClass('has-megamenu')){
      // console.log("if");
      setTimeout(function(){
      _this.parents("li").closest('.mega-menu-list-div').find('li.has-megamenu').removeClass('active');
      _this.parents("li").addClass('active');
        })
    }else{
      $(this).parents("li").closest('.mega-menu-list-div').find('li.has-megamenu').removeClass('active');
    }
  });
    $(document).on('mouseenter','.shop-mega-menu .mega-menu-list > li.has-megamenu svg.icon.icon-caret',function(e){
    // console.log("mouseneter");
    const _this = $(this);    
    if($(this).parents("li").hasClass('has-megamenu')){
      // console.log("if");
      setTimeout(function(){
      _this.parents("li").closest('.mega-menu-list-div').find('li.has-megamenu').removeClass('active');
      _this.parents("li").addClass('active');
        });
    }else{
      $(this).parents("li").closest('.mega-menu-list-div').find('li.has-megamenu').removeClass('active');
    }
  });
  //close 3rd level menu
  $(document).on('click','.mega-menu-close',function(){
    $(this).closest('.has-megamenu').removeClass('active');
  });

  //close mobile megamenu
  $(document).on('click','header-drawer .megamenu-close-main',function(e){
    e.preventDefault();
    $(this).closest('header-drawer').find('[data-close-main]').click();
  });

  //tab click mobile mega menu
  $(document).on('click', 'header-drawer [data-menu-tabs] li', function(e){
    e.preventDefault();
    let currentTabTitle = $(this).attr('data-tab-title');
    $(this).closest('[data-menu-tabs]').find('li').removeClass('active');
    $(this).addClass('active');
    $('header-drawer nav [data-menu-links]').addClass('hidden');
    $('header-drawer nav [data-menu-links="'+currentTabTitle+'"]').removeClass('hidden');
    if(currentTabTitle == 'shop'){
      $('header-drawer [data-menu-bottom]').removeClass('hidden');
    }else{
      $('header-drawer [data-menu-bottom]').addClass('hidden');
    }
  });
  
  //open-close main desktop menu
  $('.main-menu-li .has-submenu')
  .mouseenter(function(){
    var header = $('#shopify-section-header');
    if( $('#shopify-section-header').length == 0 ){
      header = $($(this).closest('.shopify-section'));
    }
    
    $(header).find('.transparent_bg_header').addClass('mouseActive');
    $(header).addClass('mouseHoverOn');
    
    if($(this).hasClass('default-layout')){
      //open default layout menu
      $('nav .default-layout details:nth-child(1)').removeAttr('open');
      $('nav .default-layout summary:nth-child(1)').attr('aria-expanded','false');
      $(this).find('details:nth-child(1)').attr('open','');
      $(this).find('summary:nth-child(1)').attr('aria-expanded','true');
    }else{
      //open megamenu layout
      if(!$(this).closest('.mega-menu-li').hasClass('active_main')){
        $('body').addClass('active_megamenu');
        $('nav .mega-menu-li').removeClass('active_main');
        $(this).closest('.mega-menu-li').addClass('active_main');
        //$('.mega-menu-list li.has-megamenu.active').removeClass('active');
      }else{
        $('body').removeClass('active_megamenu');
        $('nav .mega-menu-li').removeClass('active_main');
        //$('.mega-menu-list li.has-megamenu.active').removeClass('active');
      }
    }
  })
  .mouseleave(function(){
    var header = $('#shopify-section-header');
    if( $('#shopify-section-header').length == 0 ){
      header = $($(this).closest('.shopify-section'));
    }
    $(header).find('.transparent_bg_header').removeClass('mouseActive');
    $('body').removeClass('active_megamenu');
    $('nav .mega-menu-li').removeClass('active_main');
    $('nav .default-layout details:nth-child(1)').removeAttr('open');
    $('nav .default-layout summary:nth-child(1)').attr('aria-expanded','false');
  });
  
  //outside click closed megamenu if has open
  $('body').on("click", function(e) {
    if ($(e.target).is('body .mega-menu-main') === true || $(e.target).is('body .mega-menu-width') === true) {
      $('body').removeClass('active_megamenu');
      $('.header .mega-menu-li.active_main').removeClass('active_main');
      $('.shop-mega-menu:not(.collection-mega-menu) li.has-megamenu.active').removeClass('active');
      $('.transparent_bg_header').removeClass('mouseActive');
    }
  });
  
}

/* new js for product page */
  var pscrollCount = null;
  var pscroll= null;
  var prevDeltaY = 0;
  var blocked = false;
  function proSlickSlider(){
    /* slickPrevArrow, slickNextArrow were defiend in product setion */
    const prevArrow = typeof slickPrevArrow != 'undefined' ? slickPrevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false">Previous</button>`;
    const nextArrow = typeof slickNextArrow != 'undefined' ? slickNextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button" aria-disabled="false">Next</button>`;
    if( $('.product media-gallery slider-component .product__media-list.slider_false.sliderMobile_true').length > 0 && $(window).width() < 750 ){
      
      if( $('.product media-gallery slider-component .product__media-list.slider_false.sliderMobile_true .duplicate_li') ){
        $('.product media-gallery slider-component .product__media-list.slider_false.sliderMobile_true .duplicate_li').remove();
      }
      var _proSlickSliderMobile = $('.product media-gallery slider-component .product__media-list.slider_false.sliderMobile_true');
      /*let variWidth = $('media-gallery[id*=MediaGallery] slider-component.thumbnail-slider:not(.dulicate_thum) .thumbnail-list__item').length > 1 ? false: true;*/
      let variWidth = false;
      !variWidth ? _proSlickSliderMobile.addClass('variableWidth--false') : '';      
      setTimeout(function(){
        _proSlickSliderMobile.slick({
        dots:true, arrows: true,vertical: false, swipeToSlide: false, verticalSwiping: false, speed: 350,
        cssEase: 'cubic-bezier(0.76, 0.68, 0.13, 0.57)', infinite: false, touchThreshold: 500,
        nextArrow: nextArrow, prevArrow: prevArrow, variableWidth: variWidth,adaptiveHeight:true
      });
      })
      _proSlickSliderMobile.on('afterChange', function(event, slick, currentSlide) {        
        const dataMediaId = slick.$slider.find('.slick-current').attr('data-media-id')
        const mediaElemt = $('media-gallery[id*=MediaGallery] slider-component.thumbnail-slider .thumbnail-list__item[data-target="'+ dataMediaId +'"]:not([aria-current="true"])');
        if( mediaElemt.length ){
          if( mediaElemt.closest('media-gallery') ){
            const activeThumbnail = $(mediaElemt.closest('.thumbnail-list').find(`[data-target="${ dataMediaId }"]`))[0];
            mediaElemt.closest('media-gallery')[0].setActiveThumbnail(activeThumbnail);
          }
        }
      });
    }else{
    var _proSlickSlider = $('.product media-gallery slider-component .product__media-list.slider_true');
    _proSlickSlider.slick({
      dots:true, arrows: false,vertical: true, swipeToSlide: true, verticalSwiping: true, speed: 500,
      cssEase: 'ease-in-out', touchThreshold: 500,
      infinite: true, responsive: [{
        breakpoint: 992,
        settings: { infinite: true } }] 
      });
    
    //Implementing navigation of slides using mouse scroll
    _proSlickSlider.on('mousewheel DOMMouseScroll wheel', function(e) {
      if( $(window).width() < 992 ){ return; }
      _this = $(this);
      var deltaY = e.originalEvent.deltaY;
      e.preventDefault();
      e.stopPropagation();
  
      clearTimeout(pscroll);
      pscroll = setTimeout(function(){
          blocked = false;
      }, 50);    
  
      // clearTimeout(pscroll);
      // pscroll = setTimeout(function(){pscrollCount=0;}, 200);
      // if(pscrollCount) return 0;
      // pscrollCount=1;    
      if (deltaY > 0 && deltaY > prevDeltaY || deltaY < 0 && deltaY < prevDeltaY || !blocked) {            
        prevDeltaY = deltaY;
  
        if (deltaY > 0) {
            _this.slick('slickNext');
            blocked = true;
        }
        if (deltaY < 0) {
            _this.slick('slickPrev');
            blocked = true;
        }
      }
  
      
      /*debounce(callSlick(e, _this, blocked, deltaY), 1);*/
    });
    }
    return;
  }
  
  function callSlick(e,_this,blocked, deltaY){
    //console.log('e.originalEvent.deltaY ',e.originalEvent.deltaY);
  
    if (deltaY > 0 && deltaY > prevDeltaY || deltaY < 0 && deltaY < prevDeltaY || !blocked) {
        blocked = true;
        prevDeltaY = deltaY;
  
        if (deltaY > 0) {
            _this.slick('slickNext');
        } else {
            _this.slick('slickPrev');
        }
    }
  
    
    /*setTimeout(function(){
      if (e.originalEvent.deltaY < 0) {
        _this.slick('slickPrev');
      } else {
        _this.slick('slickNext'); }
    },1)*/
    return;
  }    
  
  function proSlickFilter(_val,_proSlickSlider){      
    _proSlickSlider.slick('slickUnfilter');
    if( _val != undefined || _val != '' ){    
      _proSlickSlider.slick('slickFilter','.'+_val);
    }
    if( _proSlickSlider.find('.hide-default').length ){
      _proSlickSlider.find('.hide-default').removeClass('hide-default');
      _proSlickSlider.slick('refresh');
    }
    return;
  }
  
  /*proSlickSlider();*/
  
  if( $('variant-color .colorList_item input:checked').length > 0 ){
    var _val = $('variant-color .colorList_item input:checked').attr('data-value');  
    $('variant-color .colorList_item input:checked').closest('.colorList_item').addClass('active');
    var _slider = $('.product media-gallery slider-component .product__media-list.slider_true');
    if( $('.product media-gallery slider-component .product__media-list.slider_false.sliderMobile_true').length > 0 && $(window).width() < 750 ){
      _slider = $('.product media-gallery slider-component .product__media-list.slider_false.sliderMobile_true');
    }  
    setTimeout(function(){ proSlickFilter(_val,_slider); },250);
  }
  
  $('media-gallery').on('click','.product__media-list.slick-initialized .slick-slide',function(){
    if( $(window).width() > 749){
    $('.product__media-list.slick-initialized').slick('slickNext'); }
  });
  
  function productDetailsRight(altText){
    if( $('[product_images]').length > 0 ){
      var product_images = JSON.parse($('[product_images]').text());
      var _count = 0, _getUrl = '', _imgWidth = 0;
      for( var i = 0; i < product_images.length; i++ ){
        var _alt = product_images[i].alt || '' ;
        if( _alt != '' && _alt.indexOf(altText) > -1 ){
          if( _count < 2 ){
            _count = _count + 1
            _getUrl = product_images[i].src;
            _imgWidth = product_images[i].width;
          }else{
            break;
          }
        }
      }
      
      if( _getUrl.indexOf('jpg') > -1 ){
        _getUrl = _getUrl.split('.jpg');
        _getUrl = _getUrl.join('_{width}x.jpg');
      }else if( _getUrl.indexOf('jpeg') > -1 ){
        _getUrl = _getUrl.split('.jpeg');
        _getUrl = _getUrl.join('_{width}x.jpeg');
      }else if( _getUrl.indexOf('png') > -1 ){
        _getUrl = _getUrl.split('.png');
        _getUrl = _getUrl.join('_{width}x.png');
      }
      if( _getUrl != '' ){
        var genratedUrl = _imageSizes(_getUrl,_imgWidth,[375,550,750,1100,1500,1780,2000,3000,3840]);    
        $('.product-details-right img').attr('srcset',genratedUrl);
      }
    }
    return;
  }
/* new js for product page &*/

$(document).on('change','.facet-checkbox input,.mobile-facets__label input',function(){
  var tag_val = $(this).val();
  var coll_handle = $('#ProductGridContainer').attr('dta-handle');
  if($(this).is(':checked')){
    if($(this).closest('.js-filter').find('summary div span').attr('data-chk') == 'ColorGroup'){
      store_tag[1].check_tag = [];
      localStorage.setItem("FilterObj", JSON.stringify(store_tag));
      store_tag[1]['check_tag'].push(tag_val);
      var store_data_local = JSON.stringify(store_tag);
      localStorage.setItem("FilterObj", store_data_local);
      setTimeout(function(){
        set_val_Swatch();
      }, 3000);
    }
  }else{
    if($(this).closest('.js-filter').find('summary div span').attr('data-chk') == 'ColorGroup'){
      store_tag[1].check_tag.splice(store_tag[1].check_tag.indexOf(tag_val), 1);
      var store_data_local = JSON.stringify(store_tag);
      localStorage.setItem("FilterObj", store_data_local);
      setTimeout(function(){
        set_val_Swatch();
      }, 3000);
    }
  }  
});

$(document).ready(function(){

  var face_main_selector = '#FacetFiltersForm .js-filter';
  if(window.innerWidth < 750){
    var face_main_selector = '#FacetFiltersFormMobile .js-filter';
  }
  $(face_main_selector).each(function(){
      if($(this).find('summary div span').attr('data-chk') == 'ColorGroup'){
          var chk_color_counter = 0;
          var last_tag = '';
          var facet_selector = '.facets__display .facets__list .list-menu__item';
          if(window.innerWidth < 750){
            var facet_selector = '.mobile-facets__submenu .mobile-facets__list .mobile-facets__item';
          }
          
          $(this).find(facet_selector).each(function(){
              if($(this).find('input').is(":checked")){
                  chk_color_counter = chk_color_counter + 1;
                  if(last_tag == ''){
                    last_tag = $(this).find('input').val();  
                  }else{
                    last_tag = last_tag +','+ $(this).find('input').val();  
                  }
              }
          });
          if(chk_color_counter == 0){
              var get_val_temp = JSON.parse(localStorage.getItem("FilterObj"));
              get_val_temp[1].check_tag=[];
              var store_data_local = JSON.stringify(get_val_temp);
              localStorage.setItem("FilterObj", store_data_local);
          }else{
              var get_val_temp = JSON.parse(localStorage.getItem("FilterObj"));
              get_val_temp[1].check_tag.push(last_tag);
              localStorage.setItem("FilterObj", JSON.stringify(get_val_temp));
          }
      }
  });
  set_val_Swatch();

  $('.featured-collection-sliders').on('afterChange', function(event, slick, currentSlide){
    $(this).find('.slick-cloned:not(.slick-cloned-changed)').each(function(index){
      var _index = index;
      $(this).find('.ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem').each(function(){
        var _id = $(this).find('label').attr('for');
        if(_id.indexOf('cloned') > -1){
          _id = _id.split('cloned')[0];
          _id = _id+'cloned'+_index;
        }else{
          _id = _id+'cloned'+_index;        
        }
        $(this).find('label').attr('for',_id);
        $(this).find('input').attr('id',_id);
        $(this).closest('.slick-cloned').addClass('slick-cloned-changed');
      });
    });
  });

  if( document.querySelector('.pro_colors_vip') != null ){
    var _makeTrigger = document.querySelector('.pro_colors_vip').closest('.ColorSwatchList').querySelectorAll('li')[0];
    $(_makeTrigger).find('input').prop('checked',false);  
    $(_makeTrigger).find('label').trigger('click');
  }
  
});

$(document).on('change','.ColorSwatch__Radio',function(event){
  let _this = $(this);
  if(_this.closest('product-recommendations').length){
    _colorChangedProductRecom(event, _this);
  }else{
   _colorChanged(event, _this);
  }
  _this.parent().siblings().find('.ColorSwatch__Radio').removeAttr('checked');
});

function set_val_Swatch(){
  // var count_product = 0;
  // if( $('body.temp-collection').length == 0 ){ return; }
  // if( $('body.temp-sale-new-suffix').length > 0 ){ return; }
  // var get_locl_val = localStorage.getItem("FilterObj");
  // if(get_locl_val){
  //   var get_val = JSON.parse(get_locl_val);
  // }else{
  //   return;
  // }
  // var count_length = get_val[1].check_tag.length, _selectedTag;
  // _selectedTag = get_val[1].check_tag[count_length-1];
  // if(count_length > 0){
  //   $('#product-grid .grid__item:not(".hidden")').each(function(){
  //   var counter_check = 0;
  //   var _this6 = $(this);
  //   var colorEachloop = $(_this6.find('.card__content .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem'));                    
  //   if( colorEachloop.length == 0 ){
  //     colorEachloop = $(_this6.find('.onhover-content .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem'));
  //   }    
  //   colorEachloop.each(function(){
  //     var chk_tag = $(this).attr('data-tag2');
  //     if($(this).hasClass("hidden")) {
  //       var chk_tag = '';
  //     }else if($(this).hasClass("soldOutColor")){
  //       var chk_tag = '';
  //     }      
  //     var _this = $(this), counter_check_temp = 0;
  //     if(chk_tag != ''){
  //       if( chk_tag != undefined && chk_tag.indexOf(',') > -1 ){
  //         var chk_tag = chk_tag.split(',');
  //         for( var i=0; i < chk_tag.length; i++ ){
  //           var _temp = chk_tag[i].trim();
  //           if(_selectedTag.indexOf(_temp) > -1 ){
  //             counter_check_temp = innerFunc(_temp, _this, _this6, counter_check);
  //             counter_check = counter_check_temp;
  //           }
  //         }
  //       }else{
  //         counter_check_temp = innerFunc(chk_tag, _this, _this6, counter_check);
  //         counter_check = counter_check_temp;
  //       }        
  //     }
  //   }).promise().done(
  //     function(){                         
  //       if(counter_check == 0){
  //          //_this6.addClass('hidden');
  //       }else{
  //         count_product = count_product + 1;
  //       }
  //     });
  //     if(typeof appendEmpty == 'function'){
  //       appendEmpty();  
  //     }
  // });
  // }

  // if(count_product > 0){
  //   $('.total-pro-wrapper .total-pro .productCount').text(count_product);
  //   // console.log("count_product",count_product);
  // }
  // function innerFunc(chk_tag, _this, _this2, _counter){
  //   /*(get_val[1].check_tag[count_length-1] == chk_tag)*/
  //   if(_selectedTag.indexOf(chk_tag) > -1){
  //     _this2.find('input[checked="checked"]').removeAttr('checked');  
  //     setTimeout(function(){
  //       _this.find('label').trigger('click');
  //     },250);
  //     _counter = _counter + 1;                        
  //     return _counter;
  //   }else{                
  //     return _counter;
  //   }
  // }

  //for template collection == new
  // if($(".new-collection-grid").length){
  //   // reinit the ajaxinte
  //   var endlessScroll = new Ajaxinate({
  //     container: '#product-grid',
  //     pagination: '#AjaxinatePagination'
  //   });
  // }
  
}

function _colorChanged(event, target) {

  // We need to change the URL of the various links
  var _hasShopLink = (target[0].getAttribute('data-shop-link') != null ? true : false) || false;
  // console.log('event',event);
  if(target.hasClass('product-total-variant')){
   _hasShopLink = true;  
  }  
  var productItem = target[0].closest('.card-wrapper');
  if( _hasShopLink == false ){
    var variantId = target[0].getAttribute('data-variant-id'),
    /*prodPrices = productItem.querySelectorAll('.ProductItem__PriceList'),*/
    variantUrl = target[0].getAttribute('data-variant-url'),
    variantPrices = target[0].getAttribute('data-variant-price'),
    checkSoldOutBadge = target.closest('.ProductItem__ColorSwatchItem')[0].className.includes('soldOutColor'),
    checkHasSalePrice = target[0].getAttribute('data-hassale-price'),
    checkBadgeDivLength = target.closest('.card-wrapper').find('.card__inner').find('.card__media').find('.coll-label-badge:not(.preOrder-label-badge)');

    var _priveDiv = target[0].closest('.card-wrapper').querySelector('.card__content .card-information .price');
    //  that is the div underneath the slider ( Hover to show slider )
    var _priveDivInSlider = target[0].closest('.card-wrapper').querySelector('.onhover-content .inner-contents .price');
    // .onhover-content .inner-contents .price
    if( variantPrices.indexOf('/') > -1 ){
      _priveDiv.classList.add('price--on-sale');    
      _priveDiv.querySelector('.price__sale .price-item--regular').innerHTML = variantPrices.split('/')[1];    
      _priveDiv.querySelector('.price__sale .price-item--sale').innerHTML  = variantPrices.split('/')[0];   
      //for _priveDivInSlider
      if(_priveDivInSlider){
        _priveDivInSlider.classList.add('price--on-sale');    
        _priveDivInSlider.querySelector('.price__sale .price-item--regular').innerHTML = variantPrices.split('/')[1];    
        _priveDivInSlider.querySelector('.price__sale .price-item--sale').innerHTML  = variantPrices.split('/')[0];
      }
      
    }else{
      _priveDiv.classList.remove('price--on-sale');
      _priveDiv.querySelector('.price__regular .price-item--regular').innerHTML = variantPrices;    
      //for _priveDivInSlider
      if(_priveDivInSlider){
        _priveDivInSlider.classList.remove('price--on-sale');
        _priveDivInSlider.querySelector('.price__regular .price-item--regular').innerHTML = variantPrices;    
      }
    }
    /*productItem.querySelector('.ProductItem__ImageWrapper').setAttribute('href', variantUrl);*/      
    
    // productItem.querySelectorAll('a.link-redirect').forEach(function(_item){
    //   _item.setAttribute('href', variantUrl);
    // });    

    // for [ new-card-product ]
    if(productItem.classList.contains("new-card-product")){
      productItem.querySelectorAll('a.proLink').forEach(function(item){
        item.setAttribute('href', variantUrl);
      }); 
    }
  
    /*product sale badge and sold out badge*/
    if(checkSoldOutBadge == true){
      if(checkBadgeDivLength.length){
        checkBadgeDivLength[0].classList.remove('badge-sale');
        checkBadgeDivLength[0].classList.add('badge-soldout');
        checkBadgeDivLength[0].innerHTML = 'Sold out';
      }
    }else{
      if(checkBadgeDivLength.length){
        if(checkHasSalePrice == 'true'){
          // Check hierarchical badges setting
          var hierarchicalBadges = target[0].closest('.grid__item').getAttribute('data-hierarchical-badges') === 'true';
          var hasNewStyle = target[0].closest('.grid__item').getAttribute('data-has-new-style') === 'true';
          
          if(hierarchicalBadges && hasNewStyle) {
            // Don't show sale badge if hierarchical badges is enabled and new style badge exists
            checkBadgeDivLength[0].innerHTML = '';
          } else {
            checkBadgeDivLength[0].classList.remove('badge-soldout');
            checkBadgeDivLength[0].classList.add('badge-sale');
            checkBadgeDivLength[0].innerHTML = 'On Sale'
          }
        }else{
          checkBadgeDivLength[0].innerHTML = '';
        }
      }
    }
    /*end-badge*/
    
    /*// Update the product price based on the selected variant
    prodPrices.forEach((price) => {
      price.getAttribute('data-variant-id') === variantId ? price.classList.remove('hidden') : price.classList.add('hidden');
    })*/
  
    // If we have a custom image for the variant, we change it
    productItem.querySelector('.card__inner .card__media').classList.remove('hide_secondary_img');
    var originalImageElement = productItem.querySelector('.card__media .media img:first-child');
    if (target[0].hasAttribute('data-image-url') && target[0].getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {    
      var _width = Number(target[0].getAttribute('data-image-width'));
      var _imageUrl = _imageSizes((target[0].getAttribute('data-image-url')),_width);        
      
      /*_imageUrl = _imageUrl + (target[0].getAttribute('data-image-url')).replace(/_{width}x/i, '');
      _imageUrl = _imageUrl +' '+_width+'w';*/
  
      newImageElement = returnimgTag(target[0], originalImageElement,
                                     target[0].getAttribute('data-image-id'),
                                     _imageUrl,_width);
  
      var originalSeondImage = productItem.querySelector('.card__media .media .secondary_img');
      if(originalSeondImage != null && target[0].getAttribute('data-secondaryimage-url') != null ){   
        var _secondSplit = target[0].getAttribute('data-secondaryimage-url').split('split');
        var _secondImageUrl = _imageSizes( _secondSplit[0] , Number(_secondSplit[2]));
        //_secondImageUrl = _secondImageUrl.substring(0, _imageUrl.length - 1);
        var newSecImageElement = returnimgTag(target[0], originalSeondImage,
                                     Number(_secondSplit[1]),
                                     _secondImageUrl, Number(_secondSplit[2]));      
        newSecImageElement.className = 'secondary_img motion-reduce'; 
        if( originalSeondImage.parentNode.querySelector('.hover-img') ){
          newSecImageElement.classList.add('hovering');
          newSecImageElement.style.opacity = '0';
        }
        originalSeondImage.parentNode.replaceChild(newSecImageElement, originalSeondImage);
      }
  
      /*// Replace the original node
      if (window.theme.productImageSize === 'natural') {
        originalImageElement.parentNode.style.paddingBottom = 100.0 / target.getAttribute('data-image-aspect-ratio') + '%';
      }
  
      originalImageElement.parentNode.style.setProperty('--aspect-ratio', target.getAttribute('data-image-aspect-ratio'));*/
      originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
      if( target[0].getAttribute('data-no-second-img') == "true" ){
        productItem.querySelector('.card__inner .card__media').classList.add('hide_secondary_img');      
      }    
    }

    // slick go to clicked variant image
  
    let selected_radioId = target[0].getAttribute('data-image-id');
    let selected_radioSlide = document.getElementById('img-item_' + selected_radioId);
    let productItemSlider = productItem.querySelector('.pro-item-slide-wrapper.slick-initialized');
    //$(productItemSlider).slick('slickGoTo', selected_radioSlide.getAttribute("data-slick-index"));
    let selctedOptVal = target[0].getAttribute('data-value-handle');
    if( productItemSlider != null ){
      $(productItemSlider).slick('slickUnfilter');      
    }else{
      PRO_CARD_SLIDER(false);      
    }
    $(productItemSlider).slick('slickFilter','[data-alt-text="'+selctedOptVal+'"]');
    if(  target[0].getAttribute('data-filtered') == null && productItem.querySelector('.shop-link[data-shop-link]') ){
      productItem.querySelector('.shop-link[data-shop-link]').setAttribute('data-filtered',true);
    }
    productItem.querySelectorAll('a[data-pd-link]').forEach(function(_item){
        _item.setAttribute('href', variantUrl);
      });
  }else{
    if(target.hasClass('product-total-variant')){
      var target = $($( target ).closest('.card').find('.card__inner .shop-link'));
    }
    if( target[0].getAttribute('data-filtered') != null ) return true;  
    let selected_radioId = target[0].closest('.card__inner').querySelector('.shop-link[data-shop-link] + .card__media img').getAttribute('data-media-id');    
    let productItemSlider = productItem.querySelector('.pro-item-slide-wrapper') || null;    
    //$(productItemSlider).slick('slickGoTo', selected_radioSlide.getAttribute("data-slick-index"));
    let selctedOptVal = target[0].closest('.card__inner').querySelector('.shop-link[data-shop-link] + .card__media img').getAttribute('data-value-handle');    
    $(productItemSlider).slick('slickUnfilter');
    $(productItemSlider).slick('slickFilter','[data-alt-text="'+selctedOptVal+'"]');
    target[0].setAttribute('data-filtered',true);
  }
  
  if( productItem.querySelector('.preOrder-label-badge') ){
    productItem.querySelector('.preOrder-label-badge').classList.add('hidden');
    if( target.attr('data-pre-order') != null && target.attr('data-pre-order') == "true" ){
      productItem.querySelector('.preOrder-label-badge').classList.remove('hidden');
    }
  }
  
  //let firstIndexofSelectedOpt = $('[data-alt-text="'+selctedOptVal+'"]').attr('data-slick-index');
  
  //end
  
}
// end -- function _colorChanged

function _colorChangedProductRecom(event, target) {  
  // We need to change the URL of the various links
  var productItem = target[0].closest('.card-wrapper'),
      variantId = target[0].getAttribute('data-variant-id'),
      /*prodPrices = productItem.querySelectorAll('.ProductItem__PriceList'),*/
      variantUrl = target[0].getAttribute('data-variant-url'),
      variantPrices = target[0].getAttribute('data-variant-price'),
  	  checkSoldOutBadge = target.closest('.ProductItem__ColorSwatchItem')[0].className.includes('soldOutColor'),
      checkHasSalePrice = target[0].getAttribute('data-hassale-price'),
      checkBadgeDivLength = target.closest('.card-wrapper').find('.card__inner').find('.card__media').find('.coll-label-badge');
       
  var _priveDiv = target[0].closest('.card-wrapper').querySelector('.card__content .card-information .price');
  if( variantPrices.indexOf('/') > -1 ){
    _priveDiv.classList.add('price--on-sale');    
    _priveDiv.querySelector('.price__sale .price-item--regular').innerHTML = variantPrices.split('/')[1];    
    _priveDiv.querySelector('.price__sale .price-item--sale').innerHTML  = variantPrices.split('/')[0];    
  }else{
    _priveDiv.classList.remove('price--on-sale');
    _priveDiv.querySelector('.price__regular .price-item--regular').innerHTML = variantPrices;    
  }

  productItem.querySelectorAll('a.proLink').forEach(function(_item){
    _item.setAttribute('href', variantUrl);
  });

  /*product sale badge and sold out badge*/
  if(checkSoldOutBadge == true){
    if(checkBadgeDivLength.length){
      checkBadgeDivLength[0].classList.remove('badge-sale');
      checkBadgeDivLength[0].classList.add('badge-soldout');
      checkBadgeDivLength[0].innerHTML = 'Sold out';
    }
  }else{
    if(checkBadgeDivLength.length){
      if(checkHasSalePrice == 'true'){
        // Check hierarchical badges setting
        var hierarchicalBadges = target[0].closest('.grid__item').getAttribute('data-hierarchical-badges') === 'true';
        var hasNewStyle = target[0].closest('.grid__item').getAttribute('data-has-new-style') === 'true';
        
        if(hierarchicalBadges && hasNewStyle) {
          // Don't show sale badge if hierarchical badges is enabled and new style badge exists
          checkBadgeDivLength[0].innerHTML = '';
        } else {
          checkBadgeDivLength[0].classList.remove('badge-soldout');
          checkBadgeDivLength[0].classList.add('badge-sale');
          checkBadgeDivLength[0].innerHTML = 'On Sale'
        }
      }else{
        checkBadgeDivLength[0].innerHTML = '';
      }
    }
  }
  /*end-badge*/

  // If we have a custom image for the variant, we change it
  productItem.querySelector('.card__inner .card__media').classList.remove('hide_secondary_img');
  var originalImageElement = productItem.querySelector('.card__media .media img:first-child');

  if (target[0].hasAttribute('data-image-url') && target[0].getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {    
    var _width = Number(target[0].getAttribute('data-image-width'));
    var _imageUrl = _imageSizes((target[0].getAttribute('data-image-url')),_width);        
    newImageElement = returnimgTag(target[0], originalImageElement, target[0].getAttribute('data-image-id'), _imageUrl,_width);

    var originalSeondImage = productItem.querySelector('.card__media .media .secondary_img');
    if(originalSeondImage != null && target[0].getAttribute('data-secondaryimage-url') != null ){   
      var _secondSplit = target[0].getAttribute('data-secondaryimage-url').split('split');
      var _secondImageUrl = _imageSizes( _secondSplit[0] , Number(_secondSplit[2]));
      var newSecImageElement = returnimgTag(target[0], originalSeondImage, Number(_secondSplit[1]), _secondImageUrl, Number(_secondSplit[2]));      
      newSecImageElement.className = 'secondary_img motion-reduce'; 
      originalSeondImage.parentNode.replaceChild(newSecImageElement, originalSeondImage);
    }

    originalImageElement.parentNode.style.setProperty('--aspect-ratio', target[0].getAttribute('data-image-aspect-ratio'));
    originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
    if( target[0].getAttribute('data-no-second-img') == "true" ){
      productItem.querySelector('.card__inner .card__media').classList.add('hide_secondary_img');      
    }    
  }
}

function _imageSizes(imageUrl,_width, _sizes = [165,360,533,720,940,1066]){
  var _imageUrl='';
  _sizes.forEach(function(_size){
      if( _width >= _size ){
        _imageUrl = _imageUrl + (imageUrl).replace(/_{width}x/i, '_'+_size+'x');
        _imageUrl = _imageUrl +' '+_size+'w,'
      }
    });
  _imageUrl = _imageUrl.substring(0, _imageUrl.length - 1);
  return _imageUrl;
}

function returnimgTag(_target,imageElement,_imageId,_imageUrl,_width){
  var newImageElement = document.createElement('img');    
    newImageElement.className = 'motion-reduce';  
    newImageElement.setAttribute('data-image-id', _imageId);
    newImageElement.setAttribute('srcset', _imageUrl);    
    newImageElement.setAttribute('sizes', imageElement.getAttribute('sizes'));
    newImageElement.setAttribute('loading','lazy');
    newImageElement.setAttribute('width', _width);
    newImageElement.setAttribute('height', 'auto');
    newImageElement.setAttribute('data-media-id','');
    newImageElement.setAttribute('data-value-handle',_target.getAttribute('data-value-handle'));
    newImageElement.setAttribute('data-widths', _target.getAttribute('data-image-widths'));
    newImageElement.setAttribute('data-sizes', 'auto');

  return newImageElement;
}

$(document).ready(() => {
  $(document).on('click','.js.product-form__input label',function(){
    var _val = $(this).parent().find('input').val();
    var _currentIndex = $(this).closest('.product-form__input').attr('data-index');
    var _genratedVAraint = _val;
    var _sliblings = $(this).closest('.product-form__input').siblings('.product-form__input');
    var _makeTriggerClick = $(this).closest('.moreThanOne').length > 0 ? false : true;
    _makeTriggerClick = window.onPageLoad != null && window.onPageLoad == true ? true : _makeTriggerClick; 
    window.onPageLoad = false;
    var mainThis = $(this);
    
    if( _sliblings.length == 1 ){
      if( _currentIndex == 2 ){
        _genratedVAraint = "RRR / "+_genratedVAraint;
      }else if( _currentIndex == 1 ){
        _genratedVAraint = _genratedVAraint +" / RRR";
      }
    }
    if( _sliblings.length == 2 ){
      if( _currentIndex == 3 ){
        _genratedVAraint = "RRR / RR1 / "+_genratedVAraint;
      }else if( _currentIndex == 2 ){
        _genratedVAraint = "RRR / "+_genratedVAraint+" / RR1";
      }else if( _currentIndex == 1 ){
        _genratedVAraint = _genratedVAraint+"/ RRR / RR1";
      }
    }
    
    if( _sliblings.length < 2 ){
      _sliblings.each(function(){
        callSlibling( $(this), _genratedVAraint, $(this).hasClass('product-form__input--dropdown') );
      });
      setTimeout(function(){
        $('.js.product-form__input .makeTriggerClick').each(function(){
          $(this).removeClass('makeTriggerClick');
          var _triggerEle = $(this).siblings(':not(.soldout-variant):not(.hide):not(.pro_skip_color)')[0] || null;
          if(_triggerEle != null && _makeTriggerClick ){
            $(_triggerEle).find('label').trigger('click');  
          }
        });
        $('.js.product-form__input .makeSlected').each(function(index,ele){
          var _child_length = $(this).closest('select').children().length;
          var _trigger_length = $(this).closest('select').find('.makeSlected').length;
          var _slodout_length = $(this).closest('select').find('.soldout-variant').length;
          if( _child_length == _slodout_length ){          
            if( mainThis.prop('tagName') == "LABEL" && index == (_trigger_length - 1)){
              var _nextSib = mainThis.closest('li').siblings(':not(.soldout-variant):not(.pro_skip_color)');
              if( _nextSib.length > 0 ){              
                $(this).closest('select').find('.makeSlected').removeClass('makeSlected');
                mainThis.closest('li').addClass('allSoldOut');
                // $(_nextSib[0]).find('label').trigger('click');
              }
            }
          }else{
            if( _child_length != _slodout_length ){
              $(this).removeClass('makeSlected');      
              var _triggerEle = $(this).siblings(':not(.soldout-variant)')[0];
                if(_triggerEle != null && _makeTriggerClick ){                
                  var _value = $(_triggerEle).val();
                  var _triggerEle = $(_triggerEle).closest('select')[0];
                  _triggerEle.value = _value;
                  //var event = new Event('change');
                  //_triggerEle.dispatchEvent(event);
                  _triggerEle.dispatchEvent(new Event('change', { bubbles: true }));
                  // document.querySelector('variant-color').onVariantChange()
                }
            }
          }
        });
        _sliblings.each(function(){
          
        if($(this).find('.ColorSwatchList').length > 0){
          if($(this).find('li.soldout-variant').length != $(this).find('li').length){
            if($(this).find('.ColorSwatchList[data-check="true"]').length > 0){
              $(this).find('li').removeClass('hide');  
            }
            // $(this).find('li input:checked').prop('checked',false);
          } 
        } 
          
      });
      },639);
    }else{  	
      _sliblings[0].each(function(){
        $(this).find('input').each(function(){        
          var _gVaraint = _genratedVAraint.replace(/RRR/i,$(this).val())
          _sliblings[1].each(function(){
            $(this).find('input').each(function(){            
              var _gVaraint = _genratedVAraint.replace(/RR1/i,$(this).val())
              if( $('.masterVariantDataUA').find('span[data-value*="'+_gVaraint+'"]').length){
                if($('.prod_soldout_show_status').val() == 'true'){
                	$(this).closest('li').addClass('soldout-variant');
                }else{
                	$(this).closest('li').addClass('soldout-variant').addClass('hide');
                }
              }else{ 
                if($('.prod_soldout_show_status').val() == 'true'){
                	$(this).closest('li').removeClass('soldout-variant'); 
                }else{
                	$(this).closest('li').removeClass('soldout-variant').removeClass('hide'); 
                }
              }
            })
          }); 
        })
      });
    }
    
    /*$('.masterVariantDataUA').find('span[data-value*="'+_val+'"]').each(function(){
  	console.log($(this));
    });*/
    return;
  });
});

function callSlibling( $this, _genratedVAraint, hasOption = false ){
  var CHILD = !hasOption ? 'input' : 'option';
  var disAttr = !hasOption ? 'disAttr' : 'disabled';
  var selectedClass = !hasOption ? '' : 'makeSlected';
  $this.find(CHILD).each(function(){
    var _closest = !hasOption ? $($(this).closest('li')) : $(this);
    var _gVaraint = _genratedVAraint.replace(/RRR/i,$(this).val());        
    if( $('.masterVariantDataUA').find('span[data-value*="'+_gVaraint+'"]').length){
      if($('.prod_soldout_show_status').val() == 'true'){
        _closest.addClass('soldout-variant').attr(disAttr,true);        
      }else{
        _closest.addClass('soldout-variant').addClass('hide').attr(disAttr,true);
      }
      var propChecked = !hasOption ? $(this).prop('checked') : $(this).attr('selected');
      propChecked = !hasOption ? propChecked : (typeof propChecked !== 'undefined' && propChecked !== false && propChecked == "selected");
      if (propChecked) {
        _closest.addClass('makeTriggerClick').addClass(selectedClass);
      }
    }else{ 
      if($('.prod_soldout_show_status').val() == 'true'){
        _closest.removeClass('soldout-variant').removeAttr(disAttr); 
      }else{
        _closest.removeClass('soldout-variant').removeClass('hide').removeAttr(disAttr); 
      } 
    }
  })
  return;
}

$('.js.product-form__input .ColorSwatchList input').each((index,ele) =>{
  const _eleValue = $(ele).val();
  const unavaiVraintLength = $('.masterVariantDataUA').find('span[data-value*="'+_eleValue+'"]').length;
  const _siblings = $(ele).closest('.product-form__input').siblings('.product-form__input');
  $(_siblings).each((index, sibEle)=>{    
    let _sibLength = 0;
    if( $(sibEle).hasClass('product-form__input--dropdown') ){      
      _sibLength = $(sibEle).find('option').length;      
    }else{
      _sibLength = $(sibEle).find('input').length;
    }
    if( unavaiVraintLength == _sibLength ){
      if( $(ele).prop('checked') == true ){
        var _nextSib = $(ele).closest('li').siblings(':not(.soldout-variant):not(.pro_skip_color)');
        if( _nextSib.length > 0 ){
          $(ele).closest('li').addClass('allSoldOut');
          // $(_nextSib[0]).find('label').trigger('click');  
        }
      }else{
        $(ele).closest('li').addClass('allSoldOut');
      }
    }else{     
      if($(ele).closest('li').length === 1){
        $(ele).closest('li').addClass('notAllSoldOut');
      }else if(!$(ele).closest('li').hasClass("soldout-variant")){
        $(ele).closest('li').addClass('notAllSoldOut');  
      }
    }
  });
})

if( $('.product-form__input.hide-sizeList').length > 0){
  $('.product-form__input.hide-sizeList').closest('.moreThanOne').removeClass('moreThanOne');
}

function blackFridayVarinats(){
  //this js will apply when :has css selector will not applied to old browser.
  if($(".bf-sale-variants-wrap li.color-list:not('.sold-variant')").length > 0){
    $('.bf-sale-variants-wrap').css('display','block');
  }
  //end
  //this js will apply when :has css selector will not applied to old browser.
    if(!$('variant-color .ColorSwatchList .colorList_item:not(.soldout-variant,.hide-list)').length){
    }
  //end
  $('[data-bf-variants] .color-list').on('click',function(e){
    e.preventDefault();
    let crntOptVal = $(this).attr('data-value');
    $('[data-bf-variants] .color-list').removeClass('active');
    $(this).addClass('active');
    //trigger mathcing variant color option
    
      $('variant-color .ColorSwatchList .colorList_item [data-color-value="'+crntOptVal+'"]').click();
      // $('variant-color .ColorSwatchList .colorList_item [data-color-value="'+crntOptVal+'"]').closest("li").find("input").trigger("click");
      // $('variant-color .ColorSwatchList .colorList_item [data-color-value="'+crntOptVal+'"]').closest("li").find("input").attr('checked',true).trigger("click");
  });
}

// START ===================== product card slider
  const PRO_CARD_SLIDER = function( callFilterEach = true ){
  $('.pro-item-slide-wrapper:not(.slick-initialized)').slick({
    dots: false,
    infinite: true,
    speed: 400,
    arrows: true,
    slidesToShow: 1,
    touchThreshold:639
  });
  if( callFilterEach ){
    $('.pro-item-slide-wrapper.slick-initialized:not(.onceFilter)').each(function(){
      var selctedOptVal = $(this).closest('.card').find('> .card__inner .card__media > a img').attr('data-value-handle') || null;
      if( selctedOptVal != null ){
        $(this).slick('slickFilter','[data-alt-text="'+selctedOptVal+'"]');
        $(this).addClass('onceFilter');
      }
    });
  }
  return;
}
// END ===================== product card slider

// START ===================== product card -> cart icon click - > to show it's slider
  window.customJs = {};
  window.customJs.productCardClick = function(){
    PRO_CARD_SLIDER();
    let cardSliderBtns = document.querySelectorAll("a[open-card-slider]:not(.eventCalled)");  
    let cardSliderBtnsHovers = document.querySelectorAll(".temp-collection .grid__item .card-product:not(.eventCalled)");
    if(cardSliderBtns.length) {
      cardSliderBtns.forEach(cardSliderBtn => {
        cardSliderBtn.classList.add('eventCalled');
        cardSliderBtn.addEventListener('click', showCardSlider.bind(this));
        /*cardSliderBtn.addEventListener('mouseover', showCardSlider.bind(this));*/
      });
    }
    if( document.querySelectorAll(".witharrow[open-card-slider]:not(.eventCalled)") != null ){
      var _aa = document.querySelectorAll(".witharrow[open-card-slider]:not(.eventCalled)");
      _aa.forEach(cardSliderBtn => {
        cardSliderBtn.classList.add('eventCalled');
        cardSliderBtn.addEventListener('click', showCardSlider.bind(this));
      });
    } 
    return true;
  }
  
  function cardHover(){
    $('.ProductItem__ColorSwatchItem label:not(called)').hover(function(){ 
        $(this).closest('.card-wrapper').find('.preOrder-label-badge').addClass('hidden');
      var preOrder = $(this).closest('ProductItem__ColorSwatchItem').find('input').attr('data-pre-order') || "false";
      var img_src = $(this).closest('.ProductItem__ColorSwatchItem').find('input').attr('data-image-url').replace('{width}','720');
      $(this).closest('.onhover-content').find('.pro-img-wrapper [data-hover-img] img').attr('src',img_src);
      $(this).closest('.onhover-content').find('.pro-img-wrapper [data-hover-img]').addClass('active');
      if( preOrder == "true" ){
        $(this).closest('.card-wrapper').find('.preOrder-label-badge').removeClass('hidden');
      }
    }, function(){
        // $(this).closest('.onhover-content').find('.pro-img-wrapper [data-hover-img] img').attr('src','');
        $(this).closest('.onhover-content').find('.pro-img-wrapper [data-hover-img]').removeClass('active');       
    });
    $('.ProductItem__ColorSwatchItem label:not(called)').addClass('called');
  }
  cardHover();
  
  // this is for coll template --> collection.new [ new-card-product.liquid ]
  function cardHoverNew(){
    // $(document).on('mouseenter','.new-collection-grid .ProductItem__ColorSwatchItem',function(){
    if($(window).width() >= 750){
      $('.new-card-product .ProductItem__ColorSwatchItem').hover(function(){   
        $(this).closest('.card-wrapper').find('.preOrder-label-badge').addClass('hidden');
        var preOrder = $(this).find('input').attr('data-pre-order') || "false";
        var img_src = $(this).find('input').attr('data-image-url').replace('{width}','720');
        $(this).closest('.card-wrapper').find('.secondary_img').css("opacity","0");
        $(this).closest('.card-wrapper').find('.secondary_img').addClass("hovering");
        $(this).closest('.card-wrapper').find('.card__media .proLink').append(`<img class="hover-img" src="${img_src}">`);        
        if( preOrder == "true" ){
          $(this).closest('.card-wrapper').find('.preOrder-label-badge').removeClass('hidden');
        }
      }, function(){
          $(this).closest('.card-wrapper').find('.secondary_img').removeAttr("style");
        $(this).closest('.card-wrapper').find('.secondary_img').removeClass("hovering");
          $(this).closest('.card-wrapper').find('.card__media .proLink .hover-img').remove();          
      });
    }
  }
  cardHoverNew();
  
  function newCard_variantCountClick(){
    $(document).on('click','[data-pro-variant-count]',function(){
      $(this).closest(".color_wrap").addClass("show-all-variant");
    });
  }
  newCard_variantCountClick();
  
  
  window.customJs.productCardClick();
  function showCardSlider(evt){
    evt.preventDefault();
    /*if( evt.type == "mouseover" )*/
  
    if( window.innerWidth < 750 ){
      let mobileTarget = evt.target;
      let mobileTargetTem =  mobileTarget.innerHTML;
      if( evt.target.closest('.card__inner') != null ){
        mobileTarget = evt.target.closest('.card').querySelector('.card__content .product-total-variant.witharrow');
        if( mobileTarget!= null ){
          mobileTargetTem =  mobileTarget.innerHTML;
        }else{
          mobileTarget = evt.target;
        }
      }
      var innerTarget = mobileTarget.closest("li.grid__item").querySelector('.onhover-content .product-total-variant:not(.innerClick)');
      if( innerTarget != null ){
        innerTarget.innerHTML = mobileTargetTem;
        innerTarget.classList.add('innerClick');
        innerTarget.addEventListener('click', showCardSlider.bind(this));
      }
    }
    
    let target = evt.currentTarget;  
    let parentLi = target.closest("li.grid__item");
    // let activeLi = parentLi.parentElement.querySelector("li.grid__item.active");
    let activeLis = document.querySelectorAll("li.grid__item.active");
    // if(activeLi)activeLi.classList.remove("active");  
  
    if(activeLis.length > 0){
      activeLis.forEach(activeLi => activeLi.classList.remove("active"));
    }
    
    parentLi.classList.add("active");
    if( target.closest(".inner-contents") != null ){
      target.closest("li.grid__item.active").classList.remove('active');
    }  
    // document.querySelector(".recently-viewed").style.paddingBottom = '';
    // if( target.closest('.recently-viewed') != null ){
    //   target.closest('.recently-viewed').classList.add('activeInRecent');      
    //   target.closest('.recently-viewed').style.paddingBottom = target.closest("li.grid__item").querySelector('.onhover-content').clientHeight - target.closest("li.grid__item").clientHeight + 10 +'px';
    // }else{
    //   if(document.querySelector(".recently-viewed").classList.contains('activeInRecent')){
    //    document.querySelector(".recently-viewed").classList.remove('activeInRecent');     
    //   }
    // }
  
    
    _colorChanged(evt, $(target)); 
  }
  
  $('.recently-viewed .grid__item').hover(function() {
      var hoverContetnPading = $(this).find('.onhover-content').height() -  $(this).height();
      $(this).closest('.recently-viewed').css('padding-bottom',hoverContetnPading);
    }, function() {
      $(this).closest('.recently-viewed').css('padding-bottom','0');
    }
  );
// END ======================= product card -> cart icon click - > to show it's slider

/* Body click */
  $(document).click(debounce(function(e){
  if( $(e.target).closest('.grid__item.active').length > 0 ){}else{
    $('.grid__item.active').removeClass('active');
  }  
  // if( $(e.target).closest('.grid__item.active').length > 0 && $(e.target).closest('.recently-viewed').length > 0 ){}else{
  //   $('.recently-viewed ').removeClass('activeInRecent');
  //   document.querySelector(".recently-viewed").style.paddingBottom = '';
  // }
}, 150));
/* Body click &*/

/* autoply Video (image-text-new) */
  $('.videoTag').each(function(index,ele){
  var _videoTag = $(this)[0];  
  if (_videoTag.paused) {    
  } else {        
  }
  _videoTag.addEventListener("playing", function() {
    $(_videoTag).closest('.videoParent').addClass('videoLoaded videoLoadedTag');     
  });
});

  window.onload = function () {
  var extranalVideos = document.querySelectorAll('.videoParent div[id*="externalVideo-"]') || [];
  if( extranalVideos.length > 0 ){
    for(var i=0; i < extranalVideos.length; i++ ){
      var ID = $(extranalVideos[i]).attr('data-section-id');
      var _sectionID = 'shopify-section-'+ID;      
      var _section = document.querySelector('#'+_sectionID);
      window[_sectionID] = {};      
      var videoContainer = document.getElementById('externalVideo-'+ID);      
      var player;
      let playerApi = '';
      let mobilePlayerApi = '';
      let options = '';
      if(typeof(videoContainer) != 'undefined' && videoContainer != null){
         options = JSON.parse(videoContainer.getAttribute('data-section-settings'));
        //console.log('options--',options);
        if(options['videoType'] === 'youtube'){
          playerApi = '//www.youtube.com/iframe_api';
        }else{
          playerApi = '//player.vimeo.com/api/player.js';
        } 
        options.playerApi = playerApi;
        if( options['mobileVideoType'] != undefined ){
          if(options['mobileVideoType'] === 'youtube'){
            mobilePlayerApi = '//www.youtube.com/iframe_api';
          }else{
            mobilePlayerApi = '//player.vimeo.com/api/player.js';
          } 
          options.mobilePlayerApi = mobilePlayerApi;
        }
        if( $(window).width() > 749 ){
          vLoadScript(false,options).then(vSetupPlayer(false, options,_section));  
        }else{
          if( options.mobilePlayerApi == undefined ){
            vLoadScript(false,options).then(vSetupPlayer(false, options,_section));
          }else{
            vLoadScript(true,options).then(vSetupPlayer(true, options,_section));
          }
        }
      }
    }
  }
};
  
  function vLoadScript(mobile = false, options) {
    return new Promise(function (resolve, reject) {
      if( options['videoType'] === 'youtube' && window.YT != undefined ) return;
      if( options['videoType'] === 'vimeo' && window.Vimeo != undefined ) return;
      // var _reFalse = noToRun(mobile);
      // if( !_reFalse && _reFalse != undefined ) return;
      //if( options.mobilePlayerApi != undefined && mobile && options.mobilePlayerApi == options.playerApi ) return;
      var script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = options.playerApi;
    });
  }
      
  function vSetupPlayer(mobile = false, options,_section) {
    var ID = $(_section).find('[id*=externalVideo-]').attr('data-section-id');
    _reFalse = noToRun(mobile, _section );
    if( !_reFalse && _reFalse != undefined ) return;        
    let elementToInsert = _section.querySelector(`#${mobile ? 'mobile':''}External__VideoHolder-${ ID }`);    

    var playerLoadingInterval = setInterval(function () {      
      if (options[mobile ? 'mobileVideoType':'videoType'] === 'youtube') {
        if (window.YT) {
          /*var temp = JSON.parse(JSON.stringify(window.YT)); window[_sectionID].YT = temp; console.log( window[_sectionID] );*/
          window.YT.ready(function() {
            player = new YT.Player(elementToInsert, {
              videoId: options[mobile ? 'mobileVideoId':'videoId'],
              playerVars: {
                showinfo: 0,
                controls: 0,
                fs: 0,
                rel: 0,
                height: '100%',
                width: '100%',
                iv_load_policy: 3,
                html5: 1,
                loop: 1,
                mute:1,
                playlist:options[mobile ? 'mobileVideoId':'videoId'],
                playsinline: 1,
                modestbranding: 1,
                disablekb: 1,
                origin: options['requestHost']
              },
              events: {
                onReady: onYouTubeReady,
                onStateChange: onYouTubeStateChange
              }
            });
          });  
          clearInterval(playerLoadingInterval);
        }        
      } else {
        if (window.Vimeo) {          
          /*var temp = JSON.parse(JSON.stringify(window.Vimeo)); window[_sectionID].Vimeo = temp; console.log( window[_sectionID] );*/
          player = new Vimeo.Player(elementToInsert.parentNode, {
            //id: options[mobile ? 'mobileVideoId':'videoId'],
            url:`https://player.vimeo.com/video/${ options[mobile ? 'mobileVideoId':'videoId'] }`,
            autoplay: true,
            muted: true,
            background: false,
            loop: true,
            controls: true
          });

          $(player.element).trigger('click');
          player.play().then(function() {
              // The video is playing
            $(elementToInsert.parentNode).closest('.videoParent').addClass('videoLoaded');
          }).catch(function(error) {
            switch (error.name) {
              case 'PasswordError':
                  // The video is password-protected
                  break;
              case 'PrivacyError':
                  // The video is private
                  break;
              default:
                  // Some other error occurred
                  break;
            }
          });
          // console.log(player,'player');
          player.on('play', function() {
            if( $(window).width() > 767 ){
              setTimeout(()=>{
                player.setVolume(1);                
              },250);
            }
            $(elementToInsert.parentNode).closest('.videoParent').addClass('videoLoaded');
            // console.log('Played the video');            
          });

          player.getVideoTitle().then(function(title) {
            console.log('title:', title);
            //player.play()
          });

          clearInterval(playerLoadingInterval);
        }            
      }
    }, 50);
    
  }
  
  function onYouTubeReady(event) {
    //console.log('options--',event);
    event.target.mute();
    event.target.playVideo();
  }

  function onYouTubeStateChange(event) {
    if (event.data === YT.PlayerState.PLAYING) {        
      if( event.target.h != null ){        
        event.target.h.closest('.videoParent').classList.add('videoLoaded');
      }
    }
    if (event.target.data === YT.PlayerState.ENDED) {
      //event.target.playVideo();
    }
  }

  function noToRun(mobile = false, _section ){    
    var skipDeskIframe = ($(_section).find('[id*=externalVideo-]').attr('data-mp4')).split(',')[0] == 'true';
    var skipMobileIframe = ($(_section).find('[id*=externalVideo-]').attr('data-mp4')).split(',')[1] == 'true';
    var hasMobileDiv = $(_section).find('[id*=externalVideo-] .mobileExternal__VideoHolder').length > 0;
    if( !skipDeskIframe && !skipMobileIframe ){
      // console.log(mobile);
      if( $(window).width() > 749 && mobile ) return false;
      if( $(window).width() < 750 && !mobile ){
        if( $(window).width() < 750 && !mobile && !hasMobileDiv ){  
          return true;
        }else{
        return false;  
        }
        
      } 
    }
    if( !skipDeskIframe && skipMobileIframe ){       
      if( $(window).width() < 750 ) return false;
    }
    if( skipDeskIframe && !skipMobileIframe){
      if( $(window).width() > 749 ) return false;        
    }
  }
/* autoply Video (image-text-new) */


//sort by click mobile view
  function sortByMobile(){
    if( $(".custom-sortyBy .facets__summary").length == 0 ) return;
    if ($(window).width() < 750 ) {    
      if( $('body[data-sortByMobile-called]').length == 1 ) return;    
      $('body').attr('data-sortByMobile-called','');
      $(document).on("click",".custom-sortyBy .facets__summary:not(.clicked)",function(evt){
        evt.preventDefault();
        let _this = $(this); _this.addClass('clickd');
        //console.log("sort clicked");
        $(".mobile-facets__open-wrapper:not([open])").trigger("click");      
        setTimeout(()=>{
        $(".mobile-facets__main .facets__disclosure.custom-sortyBy:not(.active) .mobile-facets__summary").trigger("click");      
        _this.removeClass('clickd'); },100);
      });
    }else{
      // console.log("unbind");
      $(document).bind(".custom-sortyBy .facets__summary").off( "click" );
      if( $('body[data-sortByMobile-called]').length > 0 ){
        $('body[data-sortByMobile-called]').removeAttr('data-sortByMobile-called');
      }
    }
  }
  sortByMobile();
  
  function stickyHeaderHeight(){
    // console.log("stickyHeaderHeight");
    let stickyHeader = document.querySelectorAll("sticky-header.transparent_bg_header");
    if(stickyHeader){
      stickyHeader.forEach( ele => { ele.style.marginBottom = "-" + ele.offsetHeight + "px"; });      
    }
  }
  stickyHeaderHeight();
  $(window).resize(debounce(function(e){
    sortByMobile();
    stickyHeaderHeight();
  }, 150));
// end

if(Shopify.designMode){
  document.addEventListener("shopify:section:load", function() {
    const headerContainerEle = event.target.closest('.section-header') || null;
    if(headerContainerEle){
      navigationMegaMenu();
    }
    editorModeJS();    

    /* section spacing new-banner-section */
     $('[data-section-spacing]').each(function(){
       var _json = JSON.parse($(this).text());
       $('#'+ _json.sectionId ).addClass(_json.spacing);
     });
    /* section spacing */
  });
}

//For Shopify Editor mode JS
  function editorModeJS(){
  //Featured products slick slider
  $('.featured-collection-sliders:not(role="list"):not(.slick-initialized)').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      swipeToSlide: true,
      touchThreshold:500,  
      responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
    });
  //Featured products slider - END

  //START - home page featured collection slider
  if ($(window).width() > 989 ) {
      $('.collection-list-new .collection-list:not(.slick-initialized)').slick({
      infinite: true,
      arrows: false,
      slidesToShow: 8,
      slidesToScroll: 8,
      swipeToSlide: true,
      touchThreshold:500,  
      responsive: [
          {
            breakpoint: 1700,
            settings: {
              slidesToShow: 7,
              slidesToScroll: 7
            }
          },
          {
            breakpoint: 1350,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 6
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5
            }
          }
        ]
      });
    }
  //END - home page featured collection slider

  //START - Collection shop list
  if ($(window).width() > 989 ) {
    $('.collection-shop-list .collection-list').slick({
      infinite: true,
      slidesToShow: 7,
      slidesToScroll: 7,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6
          }
        },
        {
          breakpoint: 1350,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        }
      ]
    });
  }
  //END - Collection shop list

  //START - home page featured collection slider new
    if ($(window).width() > 990 ) {
      $('.featured-collection-new .featured-coll-slider-new:not(.slick-initialized)').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 3,
        arrows: false,
        responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
              }
            }
          ]
      });
    }
  //END - home page featured collection slider new
  
}
//&& - For Shopify Editor mode JS


/**********************************Filter closed on click on Collection page start ***********************/
$(document).ready(function(){
  $('body').on('click', '.filter-inner-header', function() {
    $(this).parents("details").removeAttr("open");
  })
})
/**********************************Filter closed on click on Collection page end ***********************/



/********************************** for PDP slider thumbnail SCROLL event [ template : product-v3 ] ***********************/
if ($(window).width() >= 750 ) {
  
// Variables
let mainWindow = $(".pdp-with-thumbnail ul.product__media-list");

// Events
$(mainWindow).on('scroll', activateLink);
activateLink(); // for load event
  
function activateLink() {
  // console.log("scrolled");
  let mainWindow = $(".pdp-with-thumbnail ul.product__media-list");
  let sections = $(".pdp-with-thumbnail .product__media-item");
  let $links = $('.pdp-with-thumbnail .thumbnail-list__item');
  const yPosition = mainWindow.scrollTop();
  // console.log("yPosition",yPosition);
  for (let i = sections.length - 1; i >= 0; i -= 1) {
    const section = sections.eq(i);
    if ($(window).width() > 1200 ) {
      // console.log(">1200");
      if (yPosition >= (section[0].offsetTop - 200)) {
        // if ((yPosition + ($section[0].clientHeight/2)) >= $section[0].offsetTop) {
        if(!section.hasClass("hide-default")){
          let dataTarget = section.attr('data-media-id');
          $(".pdp-with-thumbnail .thumbnail-list__item").find("button.thumbnail").attr("aria-current",false);
          // console.log("btn",$('.thumbnail-list__item[data-target="'+ dataTarget +'"]').find("button.thumbnail"));
          // $('.thumbnail-list__item[data-target="'+ dataTarget +'"]').find("button.thumbnail").attr("aria-current",true);
          
          $(".pdp-with-thumbnail .thumbnail-list__item").removeClass("active");
          $('.pdp-with-thumbnail .thumbnail-list__item[data-target="'+ dataTarget +'"]').addClass("active");
          break;
        }
      }
    }else if($(window).width() <= 1200 && $(window).width() >= 750 ) {
      // console.log("<= 1200 && >= 750");
      // if (yPosition >= ($section[0].offsetTop - 100)) {
      if ((yPosition + (section[0].clientHeight/2) + 200) >= section[0].offsetTop) {
        if(!section.hasClass("hide-default")){
          let dataTarget = section.attr('data-media-id');
          $(".pdp-with-thumbnail .thumbnail-list__item").find("button.thumbnail").attr("aria-current",false);
          // console.log("btn",$('.thumbnail-list__item[data-target="'+ dataTarget +'"]').find("button.thumbnail"));
          // $('.thumbnail-list__item[data-target="'+ dataTarget +'"]').find("button.thumbnail").attr("aria-current",true);
          
          $(".pdp-with-thumbnail .thumbnail-list__item").removeClass("active");
          $('.pdp-with-thumbnail .thumbnail-list__item[data-target="'+ dataTarget +'"]').addClass("active");
          break;
        }
      }
    }
  }
}
}
/********************************** END for PDP slider thumbnail SCROLL event [ template : product-v3 ] ***********************/
